<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%;">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Selejtezések</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/processes/declutters/add')"
            icon="el-icon-plus"
            v-can="'declutter.create'"
          >
            Új selejtezés
          </el-button>
        </div>
        <div v-loading="loading" style="min-height: 81px;">
          <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="declutter/fetchAll"
          />
        </div>
        <declutter-list/>
        <template v-if="$route.meta.showAddDeclutterDialog">
          <declutter-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateDeclutterDialog">
          <declutter-dialog
            :declutterId="$route.params.id"
            type="update"
          />
        </template>
        <template v-if="$route.meta.showDeclutterViewDialog">
          <declutter-dialog
            :declutterId="$route.params.id"
            type="view"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
  import DeclutterList from '../../../components/processes/declutters/List';
  import DeclutterDialog from '../../../components/processes/declutters/Dialog';
  import TableFilter from '../../../components/TableFilter';
  import Sidebar from '../../../components/processes/declutters/Sidebar';

  export default {
    components: {
      DeclutterList,
      DeclutterDialog,
      TableFilter,
      Sidebar,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let storages = this.$store.getters['storage/storages'];
        let users = this.$store.getters['user/users'];
        let currencies = this.$store.getters['currency/currencies'];
        if (!storages.length) {
          await this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        if(!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        if(!currencies.length) {
          await this.$store.dispatch('currency/fetchAll');
          currencies = this.$store.getters['currency/currencies'];
        }
        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'text',
            name: 'reference_number',
            label: 'Hivatkozási szám',
          },
          {
            type: 'text',
            name: 'comment',
            label: 'Megjegyzés',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Teljesített',
                status: 'completed'
              },
              {
                label: 'Rögzítve',
                status: 'recorded'
              },
              {
                label: 'Érvénytelenítve',
                status: 'cancelled'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: storages,
            name: 'source_storage_id',
            label: 'Raktár',
            labelCallback: storage => storage && storage.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: currencies,
            name: 'currency_id',
            label: 'Deviza',
            labelCallback: currency => currency && currency.name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'creator_user_id',
            label: 'Rögzítette',
            labelCallback: user => user && user.last_name +' '+ user.first_name|| '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'completing_user_id',
            label: 'Teljesítette',
            labelCallback: user => user && user.last_name +' '+ user.first_name|| '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>
